function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useMemo } from "react";
import { logWarning } from "@rpldy/shared-ui";
import Uploady, { composeEnhancers } from "@rpldy/uploady";
import { CHUNKING_SUPPORT, getTusEnhancer } from "@rpldy/tus-sender";
const getEnhancer = (options, enhancer) => {
  const tusEnhancer = getTusEnhancer(options);
  return enhancer ? composeEnhancers(tusEnhancer, enhancer) : tusEnhancer;
};
const TusUploady = props => {
  const {
    chunked,
    chunkSize,
    retries,
    parallel,
    version,
    featureDetection,
    featureDetectionUrl,
    onFeaturesDetected,
    resume,
    deferLength,
    overrideMethod,
    sendDataOnCreate,
    storagePrefix,
    lockedRetryDelay,
    forgetOnSuccess,
    ignoreModifiedDateInStorage,
    resumeHeaders,
    ...uploadyProps
  } = props;
  const enhancer = useMemo(() => CHUNKING_SUPPORT ? getEnhancer({
    chunked,
    chunkSize,
    retries,
    parallel,
    version,
    featureDetection,
    featureDetectionUrl,
    onFeaturesDetected,
    resume,
    deferLength,
    overrideMethod,
    sendDataOnCreate,
    storagePrefix,
    lockedRetryDelay,
    forgetOnSuccess,
    ignoreModifiedDateInStorage,
    resumeHeaders
  }, props.enhancer) : undefined, [props.enhancer, chunked, chunkSize, retries, parallel, version, featureDetection, featureDetectionUrl, onFeaturesDetected, resume, deferLength, overrideMethod, sendDataOnCreate, storagePrefix, lockedRetryDelay, forgetOnSuccess, ignoreModifiedDateInStorage, resumeHeaders]);
  return /*#__PURE__*/React.createElement(Uploady, _extends({}, uploadyProps, {
    enhancer: enhancer
  }));
};
logWarning(CHUNKING_SUPPORT, "This browser doesn't support chunking. Consider using @rpldy/uploady instead");
export default TusUploady;